import { createSelector } from 'reselect'

import { selectComposedReportState } from './selectComposedReportState'

export const selectIsFilterApplied = createSelector(
  [selectComposedReportState],
  ({ isFilterApplied }) => isFilterApplied
)
